import { render, staticRenderFns } from "./AppsAnnouncements.vue?vue&type=template&id=80145e4a&"
import script from "./AppsAnnouncements.vue?vue&type=script&lang=js&"
export * from "./AppsAnnouncements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports